<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <chart-card :key='gitlab_costs_data' :chart-data="gitlab_costs_data.data"
                      :chart-options="gitlab_costs_data.options"
                      :responsive-options="gitlab_costs_data.responsiveOptions"
                      chart-type="Bar"
          >
            <template slot="header">
              <h4 class="card-title">Git Costs Breakdown by Contract</h4>
              <p class="card-category">Values in $</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle" :style='{color: colors[0]}'></i> AWS GitLab Costs
                <i class="fa fa-circle" :style='{color: colors[1]}'></i> GitLab License
                <i class="fa fa-circle" :style='{color: colors[2]}'></i> Edrans Support
              </div>
              <hr>
              <div class="stats">/
                <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
              </div>
            </template>
          </chart-card>
        </div>
        <div class="col-md-6">
          <chart-card :key='gitlab_costs_users' :chart-data="gitlab_costs_users.data"
                      :chart-options="gitlab_costs_users.options"
                      :responsive-options="gitlab_costs_users.responsiveOptions"
                      chart-type="Bar"
          >
            <template slot="header">
              <h4 class="card-title">Git Costs Breakdown by Entity</h4>
              <p class="card-category">Values in $</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <span v-for="(entity,i) in gitlab_costs_users.entities">
                  <i class="fa fa-circle" :style='{color: colors[i]}'></i>{{ entity }}
                </span>
                <!-- <i class="fa fa-circle text-warning"></i> AWS Commitment (no VAT) -->
              </div>
            </template>
          </chart-card>
        </div>
        <div class="row">
          <div class="col-xl-12">
            <h4 class="card-title">Gitlab Cost by Hub</h4>
          </div>
        </div>
        <div class="row">
            <div class="col" slot="content" v-for="(gitlab_detailed_costs_user, date) in gitlab_detailed_costs_users">
              <h4 class="btn btn btn-outline-dark btn-block btn-lg">{{ date }}</h4>
              <enhanced-table :datalist="gitlab_detailed_costs_user"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import axios from 'axios'
  import { colors, formatMoney, formatSimple } from 'src/globalVariables'
  import { setInterval } from 'timers';


  Number.prototype.pad = function(size) {
    let s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    async created() {
      this.accessToken = await this.$auth.getAccessToken()
      this.loadData();
      let vm = this;
      setInterval(function(){
        vm.loadData();
      },vm.refresh_minutes*60*1000);
    },
    methods: {
      loadData: function(){
        let today = new Date();
        this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2);
        console.log('refreshing...');
        axios
          .get('gitlab/costs?access_token=' + this.accessToken)
          .then(response => (this.gitlab_costs_infra = response.data.results));
        axios
          .get('invoices/current-data?access_token=' + this.accessToken + '&vendor_name=GitLab_License&st_date=201901&fn_date=201912')
          .then(response => (this.gitlab_costs_license = response.data));
        axios
          .get('invoices/current-data?access_token=' + this.accessToken + '&vendor_name=GitLab_Support&st_date=201908&fn_date=201912')
          .then(response => (this.gitlab_costs_support = response.data));
        axios
          .get('gitlab/users?access_token=' + this.accessToken)
          .then(response => (this.gitlab_users = response.data));
      },
      refresh_gitlab: function() {
        let [labels, series1, series2, series3] = [[], [], [], []];
        let totals = [0, 0, 0];

        if (this.gitlab_costs_infra || this.gitlab_costs_license || this.gitlab_costs_support){
          let license_cost = this.gitlab_costs_license[0]['cost']/12;
          this.gitlab_costs_infra.forEach(function(v, i){
            labels.push(v['year_month']);
            series1.push(parseFloat(v['unblended_cost'].substring(1).replace(',','')));
            series2.push(license_cost);
            totals[i] += series1[i] + series2[i];
          });

          this.gitlab_costs_support.forEach(function(v, i){
            series3[i] = v['cost'];
            totals[i] += series3[i];
          });

          let series = [series1, series2, series3];
          this.gitlab_costs_data = {
            'data': {
              'labels': labels,
              'series': series
            },
            'options': {
              'stackBars': true,
              'seriesBarWidth': 50,
              'seriesBarDistance': 50,
              'axisX': {
                'showGrid': true
              },
              'height': '245px',
              'chartPadding': {
                'right': 50,
                'left': 50,
              },
              'tooltip':{
                'tooltipFnc': function(meta, value){
                  return(value)
                },

                tooltipOffset: {
                  x: 15,
                  y: 90
                },
                'appendToBody':false,
                'transformTooltipTextFnc': function(value) {
                  return ''+ formatMoney.format(value)
                  }
              },
            },
            'responsiveOptions': [
              ['screen and (max-width: 640px)', {
                'seriesBarDistance': 6,
                'axisX': {
                  labelInterpolationFnc (value) {
                    return value[0]
                  }
                }
              }]
            ]
          }

        }
        this.get_gitlab_user_costs(labels, totals);
        this.get_gitlab_detailed_costs_users(labels, totals);
      },
      get_gitlab_user_costs: function(labels, totals) {
          let [costs, entities] = [[], []];
          let userCount = this.gitlab_users.count;
          const entries = Object.entries(this.gitlab_users.totals);
          entries.forEach(function (v,i) {
              costs[i] = [];
              entities[i] = v[0];
              totals.forEach(function(total,j){
                  costs[i][j] = (total / userCount) * v[1];
              })
          });

          this.gitlab_costs_users = {
              'entities': entities,
              'data': {
                  'labels': labels,
                  'series': costs,
              },
              'options': {
                  'stackBars': true,
                  'seriesBarWidth': 50,
                  'seriesBarDistance': 50,
                  'axisX': {
                      'showGrid': true
                  },
                  'height': '245px',
                  'chartPadding': {
                      'right': 50,
                      'left': 50,
                  },
                  'tooltip':{
                      'tooltipFnc': function(meta, value){
                          return(value)
                      },

                      tooltipOffset: {
                          x: 15,
                          y: 90
                      },
                      'appendToBody':false,
                      'transformTooltipTextFnc': function(value) {
                          return ''+ formatMoney.format(value)
                      }
                  },
              },
              'responsiveOptions': [
                  ['screen and (max-width: 640px)', {
                      'seriesBarDistance': 6,
                      'axisX': {
                          labelInterpolationFnc (value) {
                              return value[0]
                          }
                      }
                  }]
              ]
          }
      },
      get_gitlab_detailed_costs_users: function(labels, totals) {
          let data = {};
          const entities = this.gitlab_users.entity;
          let userCount = this.gitlab_users.count;

          labels.forEach(function(label, i){
            data[label] = [];
            console.log(label);
            for (let entity in entities) {
               for (let unit in entities[entity]) {
                    let users = entities[entity][unit];
                    data[label].push({
                        "entity": entity,
                        "unit": unit,
                        "users": String(users),
                        "cost": String(formatMoney.format((totals[i] / userCount) * users))
                    });
                };
            };
          });

          this.gitlab_detailed_costs_users = data;
      }
    },
    watch: {
      gitlab_costs_infra:function(){
        this.refresh_gitlab()
      },
    },
    computed: {

    },
    data () {
      return {
        refresh_minutes: 30,
        last_update: '',
        colors: colors,
        gitlab_costs_infra: {},
        gitlab_costs_license: {},
        gitlab_costs_support: {},
        gitlab_costs_data: {},
        gitlab_users: {},
        gitlab_costs_users: {},
        gitlab_detailed_costs_users: {},
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        accessToken: '',
      }
    }
  }
</script>
<style>
  h4.btn {
    background-color: #343a40;
    border-color: #343a40;
    color: #FFFFFF;
  }
</style>
